import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream-beige" data-id="element-47" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-48" data-mp="1cf9l2a9663h2">
        <div className="text-center mb-16" data-id="element-49" data-mp="1cgb7tbzjseem">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy" data-id="element-50" data-mp="2a2s4qg4dcpzu">
            ❓ Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-51" data-mp="253xami0ybf0f">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-cream-card border border-gold-light rounded-xl overflow-hidden shadow-sm" data-id="element-52" data-mp="202rh4hzgvnpu" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-53" data-mp="oonp3hcfw9nf">
                <span className="font-bold text-lg text-navy pr-8" data-id="element-54" data-mp="1pmb9yry8sreq">{faq.q}</span>
                <ChevronDown className={`text-gold transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" data-mp="1aoixk8nzsj4r" />
              </button>
              <AnimatePresence initial={false} data-id="element-56" data-mp="11ve5u1couye1">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-57" data-mp="16ps6ai67jvpk">
                    <div className="px-6 pb-5 text-ink-soft border-t border-gold-light pt-4" data-id="element-58" data-mp="n080lglf33lr">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}